import clsx from "clsx";

type SeparatorProps = {
    className?: string;
};

const Separator = ({ className }: SeparatorProps) => {
    return (
        <div className={clsx("h-px w-full bg-surface-light-5", className)} />
    );
};

export default Separator;
